import { render, staticRenderFns } from "./SwapForm.vue?vue&type=template&id=0fc5052e&"
import script from "./SwapForm.vue?vue&type=script&lang=js&"
export * from "./SwapForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports